export default __webpack_public_path__ + "static/media/RUC_EMISOR.e3440669.gif";